import ExpenseCodeData from 'Data/ExpenseCodeData';
import DataManager from 'Lib/DataManager';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import BOSFilterSelect from './index';

let DM = new DataManager();

const ExpenseCodeSelect = ({
  onSelectExpenseCode,
  defaultSelectedId,
  labelText = 'Expense Code...',
}) => {
  const [expenseCodeList, setExpenseCodeList] = useState([]);

  useEffect(() => {
    DM.add(
      ExpenseCodeData.registerListener(
        'ALL_RECORDS_LOADED',
        onExpenseCodeListLoaded,
      ),
      ExpenseCodeData,
    );
    DM.add(
      ExpenseCodeData.registerListener(
        'RECORDS_LOAD_ERROR',
        onAccountListError,
      ),
      ExpenseCodeData,
    );
  }, []);

  useEffect(() => {
    fetchExpenseCodes();
  }, []);

  const fetchExpenseCodes = () => {
    ExpenseCodeData.getAllExpenseCodes();
  };

  const onExpenseCodeListLoaded = (payload) => {
    if (payload) {
      setExpenseCodeList(payload.records);
    }
  };

  const onAccountListError = () => {};

  return (
    <BOSFilterSelect
      listData={expenseCodeList}
      defaultSelectedId={defaultSelectedId}
      onItemSelect={onSelectExpenseCode}
      placeholder={labelText}
      labelFunction={(expenseCode) => {
        return `${expenseCode.expense_code} ${expenseCode.description}`;
      }}
      searchFunction={(expenseCode) => {
        return `${expenseCode.expense_code} ${expenseCode.description}`;
      }}
    />
  );
};

ExpenseCodeSelect.propTypes = {
  onSelectExpenseCode: PropTypes.func,
  defaultSelectedId: PropTypes.number,
  labelText: PropTypes.string,
};

export default ExpenseCodeSelect;
